import { Sales } from "@/pages/sales";

export const routeSales = "/sales";
export const salesPermission = "ui.navbar.sales";

export const salesRoutes = [
	{
		path: routeSales,
		element: <Sales />,
		permission: salesPermission,
	},
];
